import React from "react";
import glyphLogo from "../assets/glyph-logo.png";
import gamigoLogo from "../assets/gamigo-logo.png";

export default function Logo () {
  const regex = /gamigo\.com/;
  const isGamigo = regex.test(window.location.hostname);

  return <div className={"logo-wrapper" + (isGamigo ? '' : ' glyph-logo')}>
    <img src={isGamigo ? gamigoLogo : glyphLogo}/>
  </div>;
}